const paymentMonitoringSection = "/payment-monitoring";

export const paymentMonitoringPath = paymentMonitoringSection;
